export enum TransactionReviewStatusModes {
  PENDING = 1,
  ACCEPTED = 2,
  AMEND = 3,
  REFUSED = 4,
  PROBLEMATIC = 5,
  REVIEWED = 6,
  'PENDING CLOSE' = 7,
}
